import { IDeviceInfo } from '@williamhill/rosi-ui-shared/src/types';

/**
 * @deprecated Should use useDeviceInfo hook instead
 */
export const getDeviceInfo = (): IDeviceInfo => {
  const deviceInfo = localStorage.getItem('deviceInfo') as string;
  return JSON.parse(deviceInfo) as IDeviceInfo;
};

export const setDeviceInfo = (deviceInfo: IDeviceInfo) => {
  localStorage.setItem('deviceInfo', JSON.stringify(deviceInfo));
  document.dispatchEvent(new Event('set-device-info'));
};
